import React, { useEffect, useState } from "react";
import { MdDeleteOutline, MdDownload } from "react-icons/md";
import { useAppDispatch } from "../../utils/redux/hooks";
import TempTwo from "../../components/helpers/walletTabs/tempTwo";
import { addcustomerOrders, addisLoading } from "../../utils/redux/mainSlice";
import { getCustomersOrders } from "../../utils/apis/func";
import { useParams } from "react-router-dom";
const Customers2 = () => {
  const [actionModal] = useState(false);
  const query = useParams();
  console.log("here", query, query?.id);
  const dispatch = useAppDispatch();
  useEffect(() => {
    const fetchCustomerOrder = async () => {
      dispatch(addisLoading(true));
      const res: any = await getCustomersOrders(query?.id);
      console.log('orders: ',res);
      if (res?.status === 200 || res?.status === 201) {
        dispatch(addcustomerOrders(res?.data?.data));
      }
      dispatch(addisLoading(false));
    };
    fetchCustomerOrder();
  }, [dispatch, query?.id]);

  return (
    <>
      <div className="relative  px-3">
        <TempTwo />
        {actionModal && (
          <>
            <>
              <div className="flex flex-col gap-8 w-full sm:w-[10rem] p-4 absolute top-44 right-[30rem] sm:right-4 z-50 rounded-md border border-[#88087B] bg-[#fff]">
                <p className="flex gap-2 items-center font-bold cursor-pointer">
                  <MdDownload size={25} className="" />
                  Export
                </p>
                <p className="flex gap-2 items-center text-[#D11C1C] font-bold cursor-pointer">
                  <MdDeleteOutline size={25} className="text-[#D11C1C]" />
                  Delete
                </p>
              </div>
            </>
          </>
        )}
      </div>
    </>
  );
};

export default Customers2;
